/** Chart Data Transform Function
 * 	Returns chartData[]
 */

const transformChartData = (data) => {
	try {
		// creating weekdata obj
		const { edges = [] } = data || {};
		const chartData = edges.map((item) => {
			return {
				daily: getTimeSelection(
					item?.node?.filters?.duration?.granularityPeriod,
					'daily'
				),
				weekly: getTimeSelection(
					item?.node?.filters?.duration?.granularityPeriod,
					'weekly'
				),
				wmWkNbr: getTimeSelection(
					item?.node?.filters?.duration?.granularityPeriod,
					'week'
				),
				monthly: getTimeSelection(
					item?.node?.filters?.duration?.granularityPeriod,
					'monthly'
				),
				tyValue: getValue(item?.node?.metrics, 'thisYear'),
				lyValue: getValue(item?.node?.metrics, 'lastYear'),
				yoy: getValue(item?.node?.metrics, 'yoyPercent'),
			};
		});

		return chartData;
	} catch (e) {
		console.log('ERROR_READING_CHART_DATA', e);
		return [];
	}
};

/** Summary Transform Function
 *	Returns summary object
 **/
const transformSummary = (data) => {
	try {
		let summary = data?.edges[0]?.node?.metrics || {};
		let summaryValue = 0;
		let summaryPctValue = 0;
		for (const key in summary) {
			// Check if the property belongs to the object itself
			if (Object.prototype.hasOwnProperty.call(summary, key)) {
				if (key?.includes('TY') && !key?.includes('YoYPctChg')) {
					summaryValue = summary[key];
				}
				if (key?.includes('YoYPctChg')) {
					summaryPctValue = summary[key];
				}
			}
		}
		return { summaryValue, summaryPctValue };
	} catch (e) {
		console.log('ERROR_READING_DATA_FROM_SUMMARY_OBJECT', e);
	}
};

// helper functions
const getTimeSelection = (timePeriod = 6, timeFrame = 'weekly') => {
	// condiiton for weekly selection need 2 keys one for tooltip and other one for chart

	// E.g. "202401" => "11"
	if (timePeriod.length === 6 && timeFrame === 'week') {
		return timePeriod.slice(4);
	}
	// E.g. "2023-12" => "1223"
	else if (timePeriod.length === 7 && timeFrame === 'monthly') {
		return timePeriod.slice(5, 7) + timePeriod.slice(2, 4);
	}
	// E.g. "2024-05-11T00:00:00.000Z" => "2024-05-11"
	else if (timePeriod.length === 10 && timeFrame === 'daily') {
		return timePeriod.slice(0, 10);
	}
	// Fallback: timeFrame = weekly	// E.g. "202411" => "202411"
	else {
		return timePeriod;
	}
};

const getValue = (metrics, context) => {
	for (const key in metrics) {
		// Check if the property belongs to the object itself
		if (Object.prototype.hasOwnProperty.call(metrics, key)) {
			// consition to handle dynamic keys and put them into expeted keys
			if (key?.includes('TY') && context === 'thisYear') {
				return metrics[key];
			}
			if (key?.includes('LY') && context === 'lastYear') {
				return metrics[key];
			}
			if (key?.includes('YoYPctChg') && context === 'yoyPercent') {
				return metrics[key];
			}
		}
	}
};

export { transformSummary, transformChartData, getTimeSelection, getValue };
